// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
// ##### 23-03-29 Komarov
import { useLocation } from 'react-router-dom';
// ##### 24-07-22 Komarov
import parse from 'html-react-parser';
import { connect, useDispatch, useSelector } from 'react-redux';
import { selectDeviceType } from '../../../../Redux/selectors';
// ##### 25-03-26 Komarov
import uniqueId from 'lodash.uniqueid';
// ##### 25-04-18 Komarov
import {
  getCitiesOverview,
  // ##### 2025-09-11 Komarov
  getHotelContent,
  getHotelsOverview,
  getLoadedPage,
} from '../../../../Redux/actions';
import Login from '../../../Library/Authorization/Login.jsx';
// ##### 25-05-21 Komarov
import YearBuilder from '../../../Library/Images/YearBuilder.jsx';
// ##### Komarov 2025-07-24
import CartGallery from '../../../Library/PageDevices/CartGallery/CartGallery.jsx';
import GroupTravelForm from '../../../Library/PageDevices/Forms/GroupTravel/GroupTravelForm/GroupTravelForm.jsx';
import PartnershipForm from '../../../Library/PageDevices/Forms/PartnershipForm/PartnershipForm.jsx';
import SupplierPartnerForm from '../../../Library/PageDevices/Forms/SupplierPartnerForm.jsx';
import Slider from '../../../Library/Slider/Slider.jsx';
// ##### 24-04-23 Komarov
import { useMessages } from '../../../../helpers/messages.js';
// ##### 24-02-21 Komarov
import ssrPages from '../../../../../server/helpers/ssrPages.js';
// ##### 24-06-17 Komarov
import ShowGallery from './ShowGallery.jsx';
// ##### 24-07-31 Komarov
import moment from 'moment';
import dateFormats from '../../../../helpers/dateFormats.js';
import { Media } from '../../../../helpers/MediaConfig.js';
// ##### 25-05-21 Komarov
import AllCitiesList from './AllCitiesList.jsx';
import AllHotelsList from './AllHotelsList.jsx';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../helpers/useValidateQuery.js';
import { isArray } from '../../../../../server/helpers/isArrayObject';
// ##### 23-09-14 Komarov
// import '../PageComponents/ResponsiveHeader/header.css'
// import './MenuPageGeneratorCSS.css'

// ##### Komarov 2025-07-14
function mapStateToProps(state) {
  return {
    cities_overview_all: state.cities.cities_overview_all,
    hotels_overview_all: state.hotels.hotels_overview_all,
    locale: state.language,
    othersName: state.othersName,
    // ##### 25-04-21 Komarov
    otherCitiesName:
      state.cities.cities_overview_top[state.language]?.data[0].data.langname,
    otherHotelsName:
      state.hotels.hotels_overview_top[state.language]?.data[0].data.langname,
  };
}

// ##### Komarov 2025-07-13
const MenuPageGenerator = connect(mapStateToProps)(({
  cities_overview_all,
  hotels_overview_all,
  locale,
  otherCitiesName,
  otherHotelsName,
}) => {
  // ##### 24-06-27 Komarov
  const location = useLocation();
  const isItHotelOverviewPage = location.pathname.includes('hotel_overview');
  // ##### 24-04-23 Komarov
  const messagesFromRedux = useMessages();

  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();

  // ##### 24-03-21 Komarov
  const src =
    'https://hotels-ua.biz/images_symlink/desktop/sitepage/210/Bucha_video.mp4';
  // ##### 23-12-27 Komarov
  const lang = locale;
  // ##### 25-04-23 Komarov
  const loadedpages = useSelector(state => state.pages.loadedpages);
  // ##### 24-08-23 Komarov
  const hotelcontent = useSelector(state => state.hotelcontent.hotelcontent);

  // ##### 25-04-23 Komarov
  let purePage;
  // ##### 25-04-23 Komarov
  if (
    (location.pathname.includes('sitepages') ||
      location.pathname.includes('city_overview') ||
      location.pathname.includes('profile')) &&
    loadedpages[search_data?.spid]?.[lang]
  ) {
    purePage = loadedpages[search_data?.spid][lang];
    // ##### 24-08-23 Komarov
  }

  const deviceType = useSelector(selectDeviceType);
  const dispatch = useDispatch();

  // ##### 24-10-28 Komarov
  const url = `${location.pathname}${location.search}`;
  let browserUrl = url.substring(3);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    browserUrl = url.substring(3);
  }, [lang, url]);

  // ##### Komarov 2025-07-21
  const isItOtherCitiesPage =
    browserUrl === ssrPages['Other Cities'] || search_data?.spid == 191;
  const isItOtherHotelsPage =
    browserUrl === ssrPages['Other Hotels'] || search_data?.spid == 365;
  // ##### 25-01-14 Komarov
  const company_id = useSelector(state => state.auth.user.company_id);

  // ##### Komarov 2025-07-12
  useEffect(
    () => {
      if (isItOtherCitiesPage) {
        const params = {
          user_id: currentUser.user_id,
          // ##### 24-08-05 Komarov
          refpartner: company_id,
          language: locale,
          primary_objects_list: 0,
          section_name: 'CITIES Overview',
        };
        dispatch(getCitiesOverview(params));
      }
    },
    // ##### 24-10-28 Komarov
    [lang, url]
  );

  // ##### Komarov 2025-07-12
  useEffect(
    () => {
      if (isItOtherHotelsPage) {
        dispatch(
          getHotelsOverview({ language: lang, primary_objects_list: 0 })
        );
      }
    },
    // ##### 24-10-28 Komarov
    [lang, url]
  );
  // ##### 25-04-21 Komarov
  const cities = cities_overview_all[lang]?.data[0]?.data?.object_list;
  const hotels = hotels_overview_all[lang]?.data[0]?.data?.object_list;
  // ##### 24-09-16 Komarov
  const { user: currentUser } = useSelector(state => state.auth);
  const { user_id } = currentUser;
  // ##### Komarov 2025-09-11
  const sale = useSelector(state => state.company.sale_id);
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);
  const promocode = useSelector(state => state.promocode.promocode);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (
      !isItOtherCitiesPage &&
      !isItOtherHotelsPage &&
      isItHotelOverviewPage
    ) {
      dispatch(getHotelContent({
        id: search_data?.id,
        city_id: search_data?.city_id,
        language: locale,
        user_id: currentUser.user_id,
        refpartner: company_id,
        sale,
        promocode,
        deviceType,
        company_cipher,
        content_size: 1,
        summary: 0,
      }));
    }
    // ##### 24-03-21 Komarov
  }, [
    search_data?.id,
    lang,
    deviceType,
    dispatch,
    // ##### 24-08-23 Komarov
    location.pathname,
    search_data?.sptid,
    search_data?.spid,
  ]);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-04-18 Komarov
    if (
      !isItOtherCitiesPage &&
      !isItOtherHotelsPage &&
      !loadedpages[search_data?.spid]?.[lang]
    ) {
      if (location.pathname.includes('city_overview')) {
        dispatch(
          getLoadedPage({
            spid: search_data?.spid,
            lang,
            deviceType,
            sitepage_type_id: search_data?.sptid,
            pageType: 'sitepagecitycontent',
            user_id,
          })
        );
      } else if (!isItHotelOverviewPage) {
        dispatch(
          getLoadedPage({
            spid: search_data?.spid,
            lang,
            deviceType,
          })
        );
      }
    }
    // ##### 24-03-21 Komarov
  }, [
    lang,
    deviceType,
    dispatch,
    // ##### 24-08-23 Komarov
    location.pathname,
    search_data?.sptid,
    search_data?.spid,
  ]);

  // ##### 24-07-31 Komarov
  const countryLocalized = useSelector(state => state.country)[locale];

  const selected_currency = useSelector(state => state.currency.pickedcurrency);
  const start = moment().add(1, 'days').format(dateFormats.en);
  const end = moment().add(2, 'days').format(dateFormats.en);

  if (isItOtherCitiesPage && cities) {
    return (
      <div className="purecontentPage" data-component="MenuPageGenerator">
        <h2>{otherCitiesName}</h2>
        <div
          style={{ overflow: 'hidden', order: '1', marginTop: '2vh' }}
          key={uniqueId()}
        >
          <Media greaterThanOrEqual="Laptop-1024-1440">
            <AllCitiesList
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
              }}
              // ##### 24-10-28 Komarov
              // cities_overview_all_data={cities_overview_all_data}
              countryLocalized={countryLocalized}
            />
          </Media>
          <Media at="Tablet-768-1024">
            <AllCitiesList
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
              }}
              // ##### 24-10-28 Komarov
              // cities_overview_all_data={cities_overview_all_data}
              countryLocalized={countryLocalized}
            />
          </Media>
          <Media lessThan="Tablet-768-1024">
            <AllCitiesList
              style={{
                display: 'grid',
              }}
              // ##### 24-10-28 Komarov
              // cities_overview_all_data={cities_overview_all_data}
              countryLocalized={countryLocalized}
            />
          </Media>
        </div>
      </div>
    );
  }

  if (isItOtherHotelsPage && hotels) {
    return (
      <div className="purecontentPage" data-component="MenuPageGenerator">
        <h2>{otherHotelsName}</h2>
        <div
          style={{ overflow: 'hidden', order: '1', marginTop: '2vh' }}
          key={uniqueId()}
        >
          <Media greaterThanOrEqual="Laptop-1024-1440">
            <AllHotelsList
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
              }}
              // ##### 24-10-28 Komarov
              // hotels_overview_all_data={hotels_overview_all_data}
              selected_currency={selected_currency}
              start={start}
              end={end}
            />
          </Media>
          <Media at="Tablet-768-1024">
            <AllHotelsList
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
              }}
              // ##### 24-10-28 Komarov
              // hotels_overview_all_data={hotels_overview_all_data}
              selected_currency={selected_currency}
              start={start}
              end={end}
            />
          </Media>
          <Media lessThan="Tablet-768-1024">
            <AllHotelsList
              style={{
                display: 'grid',
              }}
              // ##### 24-10-28 Komarov
              // hotels_overview_all_data={hotels_overview_all_data}
              selected_currency={selected_currency}
              start={start}
              end={end}
            />
          </Media>
        </div>
      </div>
    );
  }

  // ##### Komarov 2025-09-17
  const hotelImageSrcStub = `${process.env.REACT_APP_SMART_URL}images_symlink/hotel/0/Hotel_when_no_image.jpeg`;
  // ##### Komarov 2025-09-16
  const hotelData = hotelcontent ? Object.values(hotelcontent.data.hotels)[0] : null;
  if (isItHotelOverviewPage && hotelData) {
    const hotelMainImageSrc = hotelData.main_image?.[0] || hotelImageSrcStub;
    const restHotelImages = (() => hotelData.image?.length > 0 ? hotelData.image.filter(image => !isArray(image) && image !== hotelMainImageSrc) : [])();
    const hotelImages = [hotelMainImageSrc, ...restHotelImages];
    return (
      <div className="purecontentPage" data-component="MenuPageGenerator">
        <h2>{hotelData.ho_title}</h2>
        <CartGallery
          photos={hotelImages}
          photoHeight={'55vh'}
        />
        <div
          style={{ overflow: 'hidden', order: '1', marginTop: '2vh' }}
        >
          {parse(hotelData.body)}
        </div>
      </div>
    );
  }

  // ##### Komarov 2025-07-28
  const shouldShowLoader = () => !loadedpages[search_data?.spid]?.[lang] || (isItHotelOverviewPage && (!hotelcontent || !hotelData?.main_image?.length > 0));

  // ##### 25-04-01 Komarov
  if (shouldShowLoader()) {
    return <div> Loading...</div>;
  }

  // ##### 23-07-12 Komarov
  return (
    <div className="purecontentPage" data-component="MenuPageGenerator">
      {
        // ##### 24-08-23 Komarov
        purePage &&
        purePage.length > 0 &&
        purePage.map(purePageElement => {
          if (purePageElement.content_name === 'Title') {
            return (
              <React.Fragment key={uniqueId()}>
                <h2>{parse(purePageElement.text)}</h2>
              </React.Fragment>
            );
          }

          if (purePageElement.content_name === 'Image') {
            // ##### 23-09-12 Komarov
            if (
              location.pathname.includes('sitepages') ||
              location.pathname.includes('profile') ||
              location.pathname.includes('sign_in') ||
              location.pathname.includes('sign_up')
            ) {
              if (parseInt(search_data?.spid) === 18) {
                return (
                  <Slider slides={purePageElement.text} key={uniqueId()} />
                );
              }
              // ##### 24-03-21 Komarov
              if (parseInt(search_data?.spid) === 210) {
                return (
                  // ##### 23-04-12 Komarov
                  <div
                    key={uniqueId()}
                    style={{
                      background: 'lightgrey',
                      display: 'flex',
                      justifyContent: 'center',
                      borderRadius: '10px',
                    }}
                  >
                    <iframe
                      width="560"
                      height="315"
                      // style={{marginRight:'auto', marginLeft:'auto'}}
                      src={src}
                      title="YouTube video player"
                      // ##### 23-07-04 Komarov
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      // ##### 23-07-04 Komarov
                      allowFullScreen
                    />
                  </div>
                );
              }
            } else {
              return (
                <CartGallery
                  photos={purePageElement}
                  key={uniqueId()}
                  photoHeight={'55vh'}
                />
              );
            }
          }

          if (purePageElement.content_name === 'Body') {
            // ##### 23-09-12 Komarov
            if (
              location.pathname.includes('sitepages') ||
              location.pathname.includes('profile') ||
              location.pathname.includes('sign_in') ||
              location.pathname.includes('sign_up')
            ) {
              if (parseInt(search_data?.spid) === 21) {
                return (
                  // ##### 23-09-26 Komarov
                  <React.Fragment key={uniqueId()}>
                    {/* ##### 23-08-15 Komarov */}
                    {/* <YearAnimation /> */}
                    <YearBuilder />
                    {
                      // ##### 24-03-21 Komarov
                      Object.values(messagesFromRedux).length > 0 &&
                      Object.values(messagesFromRedux).map(item => {
                        if (parseInt(item.sitepage_region_id) === 12) {
                          return (
                            <ShowGallery
                              // ##### 26-06-30 Komarov
                              innerText={item.title?.[0]?.text ?? ''}
                              id={item.id}
                              key={uniqueId()}
                              componentKey={uniqueId()}
                            />
                          );
                        }
                      })
                    }
                  </React.Fragment>
                );
              }

              // ##### 24-03-21 Komarov
              if (parseInt(search_data?.spid) === 167) {
                return (
                  // ##### 23-04-12 Komarov
                  <SupplierPartnerForm
                    key={uniqueId()}
                    text={purePageElement.text}
                  />
                );
              }
              // ##### 24-03-21 Komarov
              if (parseInt(search_data?.spid) === 42) {
                return (
                  <PartnershipForm
                    text={purePageElement.text}
                    key={uniqueId()}
                  />
                );
              }
              // ##### 24-03-21 Komarov
              if (parseInt(search_data?.spid) === 187) {
                return (
                  <GroupTravelForm
                    text={purePageElement.text}
                    key={uniqueId()}
                  />
                );
              }
              // ##### 24-03-21 Komarov
              if (parseInt(search_data?.spid) === 198) {
                return (
                  // <div>Hi Kate</div>
                  <Login text={purePageElement.text} key={uniqueId()} />
                );
              }
            }
            // ##### 23-07-18 Komarov
            return (
              <div
                style={{
                  overflow: 'hidden',
                  order: '1',
                  marginTop: '2vh',
                }}
                key={uniqueId()}
              >
                {parse(purePageElement.text)}
              </div>
            );
          }
        })
      }
    </div>
  );
});

// ##### 25-05-21 Komarov
export default MenuPageGenerator;
